import { ref } from "vue";
import { b as breadcrumbPluginKey } from "../../../keys-CFfh7DXf.mjs";
const breadcrumbPlugin = {
  install(app) {
    const items = ref([]);
    const reset = () => {
      items.value.splice(0, items.value.length);
    };
    app.provide(breadcrumbPluginKey, { items, reset });
  }
};
export {
  breadcrumbPlugin
};
//# sourceMappingURL=index.mjs.map
